import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('@/views/Home.vue') },
  { path: '/search', name: 'search', component: () => import('@/views/Search.vue') },
  { path: '/t/:slug', name: 'topic', component: () => import('@/views/Topic.vue') },
  { path: '/post/:id', name: 'post', component: () => import('@/views/PostDetail.vue') },
  { path: '/login', name: 'login', component: () => import('@/views/Login.vue') },
  { path: '/me', name: 'me', component: () => import('@/views/UserCenter.vue') },
  { path: '/about', name: 'about', component: () => import('@/views/About.vue') },
  { path: '/admin', name: 'admin', component: () => import('@/views/Admin.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 同页切换 tab（仅 hash 变化）时不滚动，保留原滚动位置
    if (to.path === from.path && to.hash !== from.hash) return false
    // 后退/前进：恢复历史滚动位置（配合 Topic 的 keep-alive，列表位置原样回归）
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
})

export default router
